import { render, staticRenderFns } from "./MatchDetails.vue?vue&type=template&id=aaf3ef9c&"
import script from "./MatchDetails.vue?vue&type=script&lang=js&"
export * from "./MatchDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports